import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/h5/');
export default function cardmsgB({}: any) {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('delta_pro_new');

    return (
        <div
            className={`${css.cardmsgB} cardmsgB3 GtmModuleData-section`}
            data-section-id={css.cardmsgB}
            data-section-title={t('battery_technology_synopsis3')}
        >
            <div className="card-title">{t('battery_technology_synopsis3')} </div>
            <div className="card-desc">
                {t.rich('battery_technology_desc3', {
                    line1: (text: string) => (
                        <Link className="ef-link__page is-mobile" href="/x-stream" newWin>
                            {text}
                        </Link>
                    ),
                    line2: (text: string) => (
                        <Link className="ef-link__page is-mobile" href="/x-boost" newWin>
                            {text}
                        </Link>
                    ),
                })}
            </div>
            <div className="card-img">
                <EFPic name={[`10c.webp`, `10c.png`]} className="fullImgs" alt={t('battery_technology_synopsis3')} />
            </div>
        </div>
    );
}
